









































































































import { Component, Prop } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import ActivityDto from '@/models/Activities/ActivityDto';
import ActivityType, { ActivityTypeLabels, ActivityTypeIcons } from '@/models/Activities/ActivityType';
import ActivityStatus, { ActivityStatusLabels, ActivityStatusColors } from '@/models/Activities/ActivityStatus';
import ActivityDirection from '@/models/Activities/ActivityDirection';
import ActivityEntityType from '@/models/Activities/ActivityEntityType';
import { AppModule } from '@/store/modules/app';

@Component({
    name: 'ActivityCard'
})
export default class ActivityCard extends GiganautVue {
    @Prop({ required: true })
    activity!: ActivityDto;

    @Prop({ default: null })
    viewingEntityType!: ActivityEntityType | null;

    @Prop({ default: false })
    selected!: boolean;

    get typeLabel(): string {
        const type = this.activity.type;
        const direction = this.activity.direction;
        if (type === ActivityType.Email) {
            if (direction === 2) return 'Inbound Email';
            if (direction === 1) return 'Outbound Email';
        }
        if (type === ActivityType.Call) {
            if (direction === 2) return 'Inbound Call';
            if (direction === 1) return 'Outbound Call';
        }
        return ActivityTypeLabels[type] || 'Activity';
    }

    get activityIcon(): string {
        const type = this.activity.type;
        const direction = this.activity.direction;
        if (type === ActivityType.Email) {
            if (direction === 2) return this.IconConstants.EmailIncoming;
            if (direction === 1) return this.IconConstants.EmailOutgoing;
            return this.IconConstants.Email;
        }
        if (type === ActivityType.Call) {
            if (direction === 2) return this.IconConstants.PhoneIncoming;
            if (direction === 1) return this.IconConstants.PhoneOutgoing;
            return this.IconConstants.PhoneCall;
        }
        return ActivityTypeIcons[type] || this.IconConstants.Note;
    }

    get statusLabel(): string {
        return ActivityStatusLabels[this.activity.status] || 'Unknown';
    }

    get statusColor(): string {
        return ActivityStatusColors[this.activity.status] || 'grey';
    }

    get isTask(): boolean {
        return this.activity.type === ActivityType.Task;
    }

    get isEmail(): boolean {
        return this.activity.type === ActivityType.Email;
    }

    get isOutboundEmail(): boolean {
        return this.isEmail && this.activity.direction === ActivityDirection.Outbound;
    }

    get isInboundEmail(): boolean {
        return this.isEmail && this.activity.direction === ActivityDirection.Inbound;
    }

    get isCall(): boolean {
        return this.activity.type === ActivityType.Call;
    }

    get isMeeting(): boolean {
        return this.activity.type === ActivityType.Meeting;
    }

    get isDraft(): boolean {
        return this.activity.status === ActivityStatus.Draft;
    }

    get isCompleted(): boolean {
        return this.activity.status === ActivityStatus.Completed;
    }

    get isOverdue(): boolean {
        if (!this.activity.endAt || this.isCompleted) return false;
        return new Date(this.activity.endAt) < new Date();
    }

    get hasOwner(): boolean {
        return this.activity.owner !== null && this.activity.owner !== undefined;
    }

    get ownerName(): string {
        if (!this.activity.owner) return '';
        const person = this.activity.owner.person;
        return person ? `${person.firstName} ${person.lastName}` : '';
    }

    get ownerAvatarUrl(): string {
        if (!this.activity.owner || !this.activity.owner.avatar) return '';
        return AppModule.currentAgencyContext.storageSharedBaseUrl + '/avatars/2/' + this.activity.owner.id + '/resized-100/' + this.activity.owner.avatar;
    }

    get showRelatedTo(): boolean {
        if (!this.viewingEntityType) return false;
        const primaryType = this.activity.primaryEntityType;
        if (this.viewingEntityType === ActivityEntityType.Company) {
            return (primaryType === ActivityEntityType.Contact && this.activity.contact !== null) ||
                   (primaryType === ActivityEntityType.Location && this.activity.location !== null);
        }
        if (this.viewingEntityType === ActivityEntityType.Location) {
            return primaryType === ActivityEntityType.Contact && this.activity.contact !== null;
        }
        return false;
    }

    get relatedToLabel(): string {
        const primaryType = this.activity.primaryEntityType;
        if (primaryType === ActivityEntityType.Contact && this.activity.contact) {
            const person = this.activity.contact.person;
            if (person) return `${person.firstName} ${person.lastName}`;
            return 'Contact';
        }
        if (primaryType === ActivityEntityType.Location && this.activity.location) {
            return this.activity.location.name || 'Location';
        }
        return '';
    }

    get relatedToIcon(): string {
        const primaryType = this.activity.primaryEntityType;
        if (primaryType === ActivityEntityType.Contact) return this.IconConstants.Contact;
        if (primaryType === ActivityEntityType.Location) return this.IconConstants.Location;
        return this.IconConstants.Activity;
    }

    get relatedToRoute(): string | null {
        const primaryType = this.activity.primaryEntityType;
        if (primaryType === ActivityEntityType.Contact && this.activity.contactId) {
            return `/agency/contacts/${this.activity.contactId}`;
        }
        if (primaryType === ActivityEntityType.Location && this.activity.locationId) {
            return `/agency/locations/${this.activity.locationId}`;
        }
        return null;
    }

}
